import { useState } from "react";
export default function useOutletController() {
    const [sheetContainer, setSheetContainer] = useState();
    return {
        sheetContainer,
        setSheetContainer
    };
}
